import React from "react";
import type { NodeProps } from "@xyflow/react";
import { KgOntologyNodeCard } from "../../../molecules/KgOntologyNodeCard";
import { KgFlowNodeHandles } from "./KgFlowNodeHandles";
import type { KgFlowNode } from "../types";

export const OntologyFlowNode: React.FC<NodeProps<KgFlowNode>> = ({
  data,
  selected,
}) => (
  <>
    <KgFlowNodeHandles />
    <KgOntologyNodeCard
      name={data.title ?? ""}
      hasWarning={data.hasWarning}
      collapsed={data.collapsed}
      visualState={data.visualState}
      isSelected={selected}
    />
  </>
);

export default OntologyFlowNode;
